import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../component/Header";
import { changeActiveHeader } from "../../../redux/Reducers/GeneralReducer";
import { getCMSByKey } from "../../../redux/Actions";
import { strings } from "../../../utils/constants";

import "./terms-of-use.css";

const TermsOfUse = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { language } = useSelector((state) => state.generalReducer);
  const [cmsContent, setCmsContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(changeActiveHeader("Terms of Use"));
    fetchCMSContent();
  }, [dispatch, language]);

  const fetchCMSContent = async () => {
    setLoading(true);
    try {
      const response = await dispatch(
        getCMSByKey({ language, key: strings.cmsPages.TERMS })
      );
      if (response.payload?.success && response.payload?.data) {
        const content = JSON.parse(response.payload.data.content);
        setCmsContent({
          title: response.payload.data.title,
          title_fr: response.payload.data.title_fr,
          description: content.description,
          description_fr: content.description_fr,
        });
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const getTitle = () => {
    if (cmsContent) {
      return language === strings.language.FR
        ? cmsContent.title_fr || cmsContent.title
        : cmsContent.title;
    }
    return t("TermsOfUse");
  };

  const getDescription = () => {
    if (cmsContent) {
      return language === strings.language.FR
        ? cmsContent.description_fr
        : cmsContent.description;
    }
    return "";
  };

  return (
    <body>
      <Header />
      <section className="subplan-banner bg--primary">
        <div className="container">
          <h1 className="font-lato_bold font-26 fg-white text-center py-5 m-0">
            {getTitle()}
          </h1>
        </div>
      </section>
      <section className="py-4 py-lg-5 billing-sec bg-light">
        <div className="container pb-5">
          <div className="row">
            <div className="col-12 col-lg-8 mx-auto">
              <div className="terms-container">
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">
                        {t(strings.translate.PLEASE_WAIT)}
                      </span>
                    </div>
                  </div>
                ) : cmsContent ? (
                  <div
                    className="terms-content"
                    dangerouslySetInnerHTML={{ __html: getDescription() }}
                  />
                ) : (
                  <div className="text-center py-5 fg-gray-30">
                    <p>{t(strings.translate.NO_RECORD_FOUND)}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </body>
  );
};

export default TermsOfUse;